import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'
import styled from 'styled-components'
import { Mentee } from '../../../models/User'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { asyncGetMentees } from '../../../store/mainSlice'
import { axiosPost } from '../../Common/Axios'
import TextBox from '../../Common/TextBox'
import {
  BlueButton,
  SmallBlueButton,
  TomatoButton,
} from '../../Layout/CommonStyle'

interface OtherProps {
  setOpen?: Dispatch<SetStateAction<boolean>>
}

const SettingPopup = (props: OtherProps) => {
  const [selectedGroup, setSelectedGroup] = useState(0)
  const [selectedUser, setSelectedUser] = useState(0)
  const [mentees, setMentees] = useState<Mentee[]>([])
  const [mentee, setMentee] = useState<Mentee | null>(null)

  const dispatch = useAppDispatch()

  const menteeGroups = useAppSelector(
    (state: RootState) => state.main.menteeGroups
  )
  const me = useAppSelector((state: RootState) => state.user.me)
  const menteesLoadingStatus = useAppSelector(
    (state: RootState) => state.main.loadingStatus
  )

  const initialLoadMentees = async () => {
    if (menteeGroups.length === 0) {
      await dispatch(asyncGetMentees(me.id))
    }
  }

  // 시작시 멘티를 로딩한다
  useEffect(() => {
    initialLoadMentees()
  }, [])

  useEffect(() => {
    if (menteeGroups.length > 0) {
      if (menteeGroups.length > 0) {
        setMentees(menteeGroups[0].users)

        if (menteeGroups[0].users.length > 0) {
          setMentee(menteeGroups[0].users[0])
        }
      }
    }
  }, [menteeGroups])

  // 그룹(학교)를 바꿀때 멘티 리스트를 바꾼다.
  useEffect(() => {
    if (selectedGroup < menteeGroups.length) {
      setMentees(menteeGroups[selectedGroup].users)

      if (selectedUser < menteeGroups[selectedGroup].users.length) {
        setMentee(menteeGroups[selectedGroup].users[selectedUser])
      }
    }
  }, [selectedGroup])

  useEffect(() => {
    setMentee(mentees[selectedUser])
  }, [selectedUser])

  // group명 변경
  const updateMenteeGroup = (id: number, value: string) => {
    console.log(`${id} ${value}`)
  }

  // 멘티 정보 변경
  const handleMenteeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    const newMentee = { ...mentee, [name]: value }

    // setMentee(newMentee)
  }

  // 그룹 멘티 전체 상호친구 맺기
  const handleMakeFriendAllGroup = async () => {
    if (
      selectedGroup < 0 ||
      menteeGroups.length <= selectedGroup ||
      confirm('그룹 전체 멘티간 친구를 맺으시겠습니까?') === false
    ) {
      return
    }

    const payload = {
      menteeGroupId: menteeGroups[selectedGroup].userGroup.id,
    }

    const result = await axiosPost('/api/mentor/make_friend_in_group', payload)
    if (result !== 'success') {
      return
    }

    // TODO: reload
  }

  return (
    <Container>
      <Title>멘티 그룹관리</Title>
      <Content>
        <GroupList>
          <BlueButton>추가</BlueButton>
          <ListUl>
            {menteeGroups &&
              menteeGroups.map((menteeGroup, index) => (
                <Item
                  key={index}
                  value={selectedGroup === index ? 'selected' : ''}
                  onClick={() => setSelectedGroup(index)}
                >
                  {menteeGroup.userGroup.name}
                </Item>
              ))}
          </ListUl>
        </GroupList>
        <Detail>
          <Top>
            <GroupInfo>
              <TextBox
                width={120}
                updateId={menteeGroups[selectedGroup].userGroup.id}
                value={menteeGroups[selectedGroup].userGroup.name}
                placeholder=""
                updateValue={(s: string) =>
                  updateMenteeGroup(menteeGroups[selectedGroup].userGroup.id, s)
                }
              />
              <BlueButton onClick={() => handleMakeFriendAllGroup()}>
                그룹전체 상호친구 맺기
              </BlueButton>
              <TomatoButton>삭제</TomatoButton>
            </GroupInfo>
          </Top>
          <Buttons></Buttons>
          <MenteeInfo>
            <ListUl>
              {mentees &&
                mentees.map((mentee, index) => (
                  <>
                    <Item
                      key={index}
                      value={selectedUser === index ? 'selected' : ''}
                      onClick={() => setSelectedUser(index)}
                    >
                      {mentee.checked ? 'v' : ''} {mentee.mentee.username}
                    </Item>
                  </>
                ))}
            </ListUl>
            <div>
              <InputLine>
                <div>이름</div>
                <input
                  type="text"
                  name="username"
                  onChange={handleMenteeChange}
                  value={mentee?.mentee.username ?? ''}
                />
              </InputLine>
              <InputLine>
                <div>아이디</div>
                <input
                  type="text"
                  name="userid"
                  onChange={handleMenteeChange}
                  value={mentee?.mentee.userid ?? ''}
                />
              </InputLine>
              <InputLine>
                <div>E-mail</div>
                <input
                  type="text"
                  name="email"
                  onChange={handleMenteeChange}
                  value={mentee?.mentee.email ?? ''}
                />
              </InputLine>
              <Buttons>
                <BlueButton>저장</BlueButton>
                <TomatoButton>삭제</TomatoButton>
              </Buttons>
            </div>
          </MenteeInfo>
        </Detail>
      </Content>
    </Container>
  )
}

const Container = styled.div``

const Title = styled.div`
  font-size: 1.4rem;
  font-weight: bold;
  text-align: center;
  padding-bottom: 20px;
`
const Content = styled.div`
  grid-area: leftside;
  display: flex;
  flex-direction: row;
  column-gap: 20px;
`

const ListUl = styled.ul`
  border-top: 1px solid #ddd;
  margin-top: 10px;
  max-height: 400px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ddd;
  }
  &::-webkit-scrollbar-track {
    background-color: white;
  }
`

const GroupList = styled.div`
  padding: 5px;
`

const Detail = styled.div`
  input {
    padding: 5px 10px;
  }
`
const Top = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 2px solid #ddd;

  & > div:nth-child(1) {
    padding-top: 15px;
    padding-left: 4px;
  }
`

const GroupInfo = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 4px;
  column-gap: 10px;
  padding-bottom: 20px;

  & > div:nth-child(1) {
    min-width: 120px;
    text-align: center;
    background-color: white;
  }
  & > button {
    margin-top: 0;
  }
`

const InputLine = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;

  div {
    text-align: right;
    padding-right: 20px;
    padding-top: 3px;
    width: 70px;
  }
  & > input {
    padding: 5px 10px;
  }
`
const Buttons = styled.div`
  text-align: right;
`
const Item = styled.li`
  list-style: none;
  padding: 10px 40px;
  border-bottom: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  cursor: pointer;

  background-color: ${(props) =>
    props.value && props.value === 'selected' ? '#ffbc2c' : 'white'};

  &:hover {
    background-color: ${(props) =>
      props.value && props.value === 'selected' ? '#ffbc2c' : 'aliceblue'};
  }
`
const MenteeInfo = styled.div`
  display: flex;
  flex-direction: row;

  & > div:nth-child(2) {
    padding: 20px;
  }
`

export default SettingPopup
